import { CREDIT_REPORT_PRODUCT_SLUG } from '@/configuration/client';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/credit-reports-b2c/reports/creator/{creatorSlug}/product/{productSlug}']['GET'];
type Input = { creatorSlug: string };

const getNoodleProducts = async ({ creatorSlug }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get(
    `/credit-reports-b2c/reports/creator/${creatorSlug}/product/${CREDIT_REPORT_PRODUCT_SLUG}`,
  );
  return response.data;
};

export default getNoodleProducts;
